import React from 'react';
import './gallery.scss';
import PlayButton from '../../assets/Play.svg';
import XIcon from '../../assets/x.svg';
import SVGInline from 'react-svg-inline';
import ReactPlayerLoader from '@brightcove/react-player-loader'


export default class GalleryCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showVideo: false,
      videoPlayer: null
    };
    this.toggleVideo = this.toggleVideo.bind(this);
    this.onSuccess = this.onSuccess.bind(this);
  }

  toggleVideo(e) {
    if (e) e.preventDefault();
    this.setState(prevState => ({ showVideo: !prevState.showVideo }));
  }

  onSuccess(success) {
    this.setState({ videoPlayer: success && success.ref });
  }

  renderVideo(slide) {
    // Vimeo or Brightcove embed code support
    if (slide.VideoEmbedCode) {
      // Try to force autoplay for Vimeo embeds
      let embedCode = slide.VideoEmbedCode;
      // Add autoplay=1 to Vimeo iframe src if not present
      embedCode = embedCode.replace(
        /(https:\/\/player.vimeo.com\/video\/\d+)([^"]*)/,
        (match, p1, p2) => {
          if (p2.includes('autoplay=1')) return match;
          if (p2.includes('?')) return p1 + p2 + '&autoplay=1';
          return p1 + '?autoplay=1' + p2;
        }
      );
      return (
        <div className="inline-window--wrapper" style={{ display: 'block', opacity: 1 }}>
          <div className="inline-window--bg" onClick={this.toggleVideo} />
          <div className="inline-window">
            <div className="inline-window--content-area">
              <div className="inline-content inline-window--content">
                <div className="video-component" aria-hidden="true">
                  <div dangerouslySetInnerHTML={{ __html: embedCode }} />
                </div>
              </div>
            </div>
            <a className="btn inline-window--close-btn" target="_self" name="Close" title="Close button" onClick={this.toggleVideo}>
              <span className="gallery-close-x">×</span>
            </a>
          </div>
        </div>
      );
    } else if (slide.VideoId) {
      // Brightcove static embed with autoplay
      return (
        <div className="inline-window--wrapper" style={{ display: 'block', opacity: 1 }}>
          <div className="inline-window--bg" onClick={this.toggleVideo} />
          <div className="inline-window">
            <div className="inline-window--content-area">
              <div className="inline-content inline-window--content">
                <div className="video-component" aria-hidden="true">
                  <div style={{ position: 'relative', display: 'block', maxWidth: '100%' }}>
                    <div style={{ paddingTop: '56.25%' }}>
                      <iframe
                        src={`https://players.brightcove.net/993020718001/default_default/index.html?videoId=${slide.VideoId}&autoplay=true`}
                        allowFullScreen
                        allow="encrypted-media"
                        style={{ position: 'absolute', top: 0, right: 0, bottom: 0, left: 0, width: '100%', height: '100%' }}
                        frameBorder="0"
                        title="Brightcove Video"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <a className="btn inline-window--close-btn" target="_self" name="Close" title="Close button" onClick={this.toggleVideo}>
              <span className="gallery-close-x">×</span>
            </a>
          </div>
        </div>
      );
    }
    return null;
  }

  render() {
    const { slide } = this.props;
    const { showVideo } = this.state;

    // If slide.Type and slide.Content are present, use alternate rendering logic
    if (slide.Type && slide.Content) {
      if (slide.SlideLink) {
        return (
          <a href={slide.SlideLink} rel="noreferrer" target="_blank">
            <div className='gallery-slide swiper-slide'>
              {slide.Type === 'Image' && <img alt={slide.Headline} className='gallery-image' src={slide.Content} />}
              {slide.Type === 'Video' && <div className='video-component' dangerouslySetInnerHTML={{ __html: slide.Content }} />}
            </div>
          </a>
        );
      } else {
        return (
          <div className='gallery-slide swiper-slide'>
            {slide.Type === 'Image' && <img alt={slide.Headline} className='gallery-image' src={slide.Content} />}
            {slide.Type === 'Video' && <div className='video-component' dangerouslySetInnerHTML={{ __html: slide.Content }} />}
          </div>
        );
      }
    }

    // Default: image with play button and video overlay
    return (
      <div className="gallery-slide">
        {!showVideo ? (
          <div className="gallery-slide-img-container" style={{ position: 'relative' }}>
            <img src={slide.ImageUrl} alt={slide.Headline} className="gallery-slide-img" />
            {slide.HasVideo && (
  <button title='play button' className='gallery-play-btn' onClick={this.toggleVideo}>
    <SVGInline className='icon' svg={PlayButton} />
  </button>
)}
            //   
            )
            {/* Optionally show caption */}
          </div>
        ) : (
          this.renderVideo(slide)
        )}
      </div>
    );
  }
}
